/* tslint:disable */
/* eslint-disable */
/**
 * IDP Service API
 * Handles Identity Provider (IDP) logic and authentication flows
 *
 * The version of the OpenAPI document: 0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base.js';
export const LinkedProviderDtoProviderEnum = {
    Google: 'google',
    Facebook: 'facebook'
};
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Issue CSRF token cookie (double-submit)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCsrf: async (options = {}) => {
            const localVarPath = `/api/auth/csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Password: Initiate reset flow (always 204)
         * @param {string} userAgent
         * @param {ForgotPasswordDto} forgotPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword: async (userAgent, forgotPasswordDto, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('authControllerForgotPassword', 'userAgent', userAgent);
            // verify required parameter 'forgotPasswordDto' is not null or undefined
            assertParamExists('authControllerForgotPassword', 'forgotPasswordDto', forgotPasswordDto);
            const localVarPath = `/api/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null && typeof window === 'undefined') {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Profile: Retrieve current user profile (read-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetProfile: async (options = {}) => {
            const localVarPath = `/api/auth/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Issue a short-lived biometric grant (device-bound)
         * @param {string} userAgent
         * @param {IssueBiometricGrantDto} issueBiometricGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerIssueBiometricGrant: async (userAgent, issueBiometricGrantDto, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('authControllerIssueBiometricGrant', 'userAgent', userAgent);
            // verify required parameter 'issueBiometricGrantDto' is not null or undefined
            assertParamExists('authControllerIssueBiometricGrant', 'issueBiometricGrantDto', issueBiometricGrantDto);
            const localVarPath = `/api/auth/biometric-grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null && typeof window === 'undefined') {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(issueBiometricGrantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary User login (issues tokens or returns MFA challenge)
         * @param {any} body User credentials
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (body, userAgent, xClientAudience, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authControllerLogin', 'body', body);
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null && typeof window === 'undefined') {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            if (xClientAudience != null) {
                localVarHeaderParameter['x-client-audience'] = String(xClientAudience);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Logout current user (revoke active session by JWT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout: async (options = {}) => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Refresh: Rotate refresh and access tokens
         * @param {string} userAgent
         * @param {RefreshDto} refreshDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh: async (userAgent, refreshDto, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('authControllerRefresh', 'userAgent', userAgent);
            // verify required parameter 'refreshDto' is not null or undefined
            assertParamExists('authControllerRefresh', 'refreshDto', refreshDto);
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null && typeof window === 'undefined') {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(refreshDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Registration: Create a new user
         * @param {RegisterDto} registerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister: async (registerDto, options = {}) => {
            // verify required parameter 'registerDto' is not null or undefined
            assertParamExists('authControllerRegister', 'registerDto', registerDto);
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Registration: Create a new user from a social signup token and issue login tokens
         * @param {string} userAgent
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegisterSocial: async (userAgent, body, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('authControllerRegisterSocial', 'userAgent', userAgent);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authControllerRegisterSocial', 'body', body);
            const localVarPath = `/api/auth/register-social`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null && typeof window === 'undefined') {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Password: Complete reset with a valid token
         * @param {string} userAgent
         * @param {ResetPasswordDto} resetPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword: async (userAgent, resetPasswordDto, options = {}) => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('authControllerResetPassword', 'userAgent', userAgent);
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('authControllerResetPassword', 'resetPasswordDto', resetPasswordDto);
            const localVarPath = `/api/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Registration: Verify email address with token (placeholder)
         * @param {VerifyEmailDto} verifyEmailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyEmail: async (verifyEmailDto, options = {}) => {
            // verify required parameter 'verifyEmailDto' is not null or undefined
            assertParamExists('authControllerVerifyEmail', 'verifyEmailDto', verifyEmailDto);
            const localVarPath = `/api/auth/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary MFA: Verify code to complete login (no JWT required)
         * @param {VerifyLoginMfaDto} verifyLoginMfaDto
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyLoginMfa: async (verifyLoginMfaDto, userAgent, xClientAudience, options = {}) => {
            // verify required parameter 'verifyLoginMfaDto' is not null or undefined
            assertParamExists('authControllerVerifyLoginMfa', 'verifyLoginMfaDto', verifyLoginMfaDto);
            const localVarPath = `/api/auth/mfa/verify-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }
            if (xClientAudience != null) {
                localVarHeaderParameter['x-client-audience'] = String(xClientAudience);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyLoginMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Issue CSRF token cookie (double-submit)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCsrf(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCsrf(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerCsrf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Password: Initiate reset flow (always 204)
         * @param {string} userAgent
         * @param {ForgotPasswordDto} forgotPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerForgotPassword(userAgent, forgotPasswordDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerForgotPassword(userAgent, forgotPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Profile: Retrieve current user profile (read-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerGetProfile(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerGetProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerGetProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Issue a short-lived biometric grant (device-bound)
         * @param {string} userAgent
         * @param {IssueBiometricGrantDto} issueBiometricGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerIssueBiometricGrant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary User login (issues tokens or returns MFA challenge)
         * @param {any} body User credentials
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(body, userAgent, xClientAudience, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(body, userAgent, xClientAudience, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Logout current user (revoke active session by JWT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogout(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Refresh: Rotate refresh and access tokens
         * @param {string} userAgent
         * @param {RefreshDto} refreshDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRefresh(userAgent, refreshDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRefresh(userAgent, refreshDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Registration: Create a new user
         * @param {RegisterDto} registerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRegister(registerDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRegister(registerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Registration: Create a new user from a social signup token and issue login tokens
         * @param {string} userAgent
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRegisterSocial(userAgent, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRegisterSocial(userAgent, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerRegisterSocial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Password: Complete reset with a valid token
         * @param {string} userAgent
         * @param {ResetPasswordDto} resetPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResetPassword(userAgent, resetPasswordDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResetPassword(userAgent, resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Registration: Verify email address with token (placeholder)
         * @param {VerifyEmailDto} verifyEmailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyEmail(verifyEmailDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyEmail(verifyEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerVerifyEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary MFA: Verify code to complete login (no JWT required)
         * @param {VerifyLoginMfaDto} verifyLoginMfaDto
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authControllerVerifyLoginMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthenticationApiFp(configuration);
    return {
        /**
         *
         * @summary Issue CSRF token cookie (double-submit)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCsrf(options) {
            return localVarFp.authControllerCsrf(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Password: Initiate reset flow (always 204)
         * @param {string} userAgent
         * @param {ForgotPasswordDto} forgotPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword(userAgent, forgotPasswordDto, options) {
            return localVarFp.authControllerForgotPassword(userAgent, forgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Profile: Retrieve current user profile (read-only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetProfile(options) {
            return localVarFp.authControllerGetProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Issue a short-lived biometric grant (device-bound)
         * @param {string} userAgent
         * @param {IssueBiometricGrantDto} issueBiometricGrantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options) {
            return localVarFp.authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User login (issues tokens or returns MFA challenge)
         * @param {any} body User credentials
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(body, userAgent, xClientAudience, options) {
            return localVarFp.authControllerLogin(body, userAgent, xClientAudience, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Logout current user (revoke active session by JWT)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout(options) {
            return localVarFp.authControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Refresh: Rotate refresh and access tokens
         * @param {string} userAgent
         * @param {RefreshDto} refreshDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh(userAgent, refreshDto, options) {
            return localVarFp.authControllerRefresh(userAgent, refreshDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Registration: Create a new user
         * @param {RegisterDto} registerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister(registerDto, options) {
            return localVarFp.authControllerRegister(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Registration: Create a new user from a social signup token and issue login tokens
         * @param {string} userAgent
         * @param {any} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegisterSocial(userAgent, body, options) {
            return localVarFp.authControllerRegisterSocial(userAgent, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Password: Complete reset with a valid token
         * @param {string} userAgent
         * @param {ResetPasswordDto} resetPasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword(userAgent, resetPasswordDto, options) {
            return localVarFp.authControllerResetPassword(userAgent, resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Registration: Verify email address with token (placeholder)
         * @param {VerifyEmailDto} verifyEmailDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyEmail(verifyEmailDto, options) {
            return localVarFp.authControllerVerifyEmail(verifyEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary MFA: Verify code to complete login (no JWT required)
         * @param {VerifyLoginMfaDto} verifyLoginMfaDto
         * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
         * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options) {
            return localVarFp.authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     *
     * @summary Issue CSRF token cookie (double-submit)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerCsrf(options) {
        return AuthenticationApiFp(this.configuration).authControllerCsrf(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Password: Initiate reset flow (always 204)
     * @param {string} userAgent
     * @param {ForgotPasswordDto} forgotPasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerForgotPassword(userAgent, forgotPasswordDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerForgotPassword(userAgent, forgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Profile: Retrieve current user profile (read-only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerGetProfile(options) {
        return AuthenticationApiFp(this.configuration).authControllerGetProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Issue a short-lived biometric grant (device-bound)
     * @param {string} userAgent
     * @param {IssueBiometricGrantDto} issueBiometricGrantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerIssueBiometricGrant(userAgent, issueBiometricGrantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User login (issues tokens or returns MFA challenge)
     * @param {any} body User credentials
     * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
     * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerLogin(body, userAgent, xClientAudience, options) {
        return AuthenticationApiFp(this.configuration).authControllerLogin(body, userAgent, xClientAudience, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Logout current user (revoke active session by JWT)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerLogout(options) {
        return AuthenticationApiFp(this.configuration).authControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Refresh: Rotate refresh and access tokens
     * @param {string} userAgent
     * @param {RefreshDto} refreshDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerRefresh(userAgent, refreshDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerRefresh(userAgent, refreshDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Registration: Create a new user
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerRegister(registerDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerRegister(registerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Registration: Create a new user from a social signup token and issue login tokens
     * @param {string} userAgent
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerRegisterSocial(userAgent, body, options) {
        return AuthenticationApiFp(this.configuration).authControllerRegisterSocial(userAgent, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Password: Complete reset with a valid token
     * @param {string} userAgent
     * @param {ResetPasswordDto} resetPasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerResetPassword(userAgent, resetPasswordDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerResetPassword(userAgent, resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Registration: Verify email address with token (placeholder)
     * @param {VerifyEmailDto} verifyEmailDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerVerifyEmail(verifyEmailDto, options) {
        return AuthenticationApiFp(this.configuration).authControllerVerifyEmail(verifyEmailDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary MFA: Verify code to complete login (no JWT required)
     * @param {VerifyLoginMfaDto} verifyLoginMfaDto
     * @param {string} [userAgent] Optional client user-agent; used for security logging and analytics.
     * @param {string} [xClientAudience] Optional client audience. Use \&#39;teetime-web\&#39; (default) or \&#39;teetime-admin\&#39; if permitted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options) {
        return AuthenticationApiFp(this.configuration).authControllerVerifyLoginMfa(verifyLoginMfaDto, userAgent, xClientAudience, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Aggregate health check (non-gating providers excluded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck: async (options = {}) => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Liveness check (always 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerLive: async (options = {}) => {
            const localVarPath = `/api/health/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Providers/external dependencies check (non-gating)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerProviders: async (options = {}) => {
            const localVarPath = `/api/health/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Readiness check (DB/Redis only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerReady: async (options = {}) => {
            const localVarPath = `/api/health/ready`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Aggregate health check (non-gating providers excluded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Liveness check (always 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerLive(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerLive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Providers/external dependencies check (non-gating)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerProviders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Readiness check (DB/Redis only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerReady(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerReady(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerReady']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthApiFp(configuration);
    return {
        /**
         *
         * @summary Aggregate health check (non-gating providers excluded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Liveness check (always 200)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerLive(options) {
            return localVarFp.healthControllerLive(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Providers/external dependencies check (non-gating)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerProviders(options) {
            return localVarFp.healthControllerProviders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Readiness check (DB/Redis only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerReady(options) {
            return localVarFp.healthControllerReady(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     *
     * @summary Aggregate health check (non-gating providers excluded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerCheck(options) {
        return HealthApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Liveness check (always 200)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerLive(options) {
        return HealthApiFp(this.configuration).healthControllerLive(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Providers/external dependencies check (non-gating)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerProviders(options) {
        return HealthApiFp(this.configuration).healthControllerProviders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Readiness check (DB/Redis only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerReady(options) {
        return HealthApiFp(this.configuration).healthControllerReady(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MFAApi - axios parameter creator
 * @export
 */
export const MFAApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Dev: Generate WhatsApp MFA backup codes (single-use)
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerGenerateWhatsAppBackupCodes: async (generateBackupCodeDto, options = {}) => {
            // verify required parameter 'generateBackupCodeDto' is not null or undefined
            assertParamExists('mfaControllerGenerateWhatsAppBackupCodes', 'generateBackupCodeDto', generateBackupCodeDto);
            const localVarPath = `/api/mfa/whatsapp/backup/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(generateBackupCodeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initiate SMS MFA for login by sending an OTP
         * @param {InitiateSmsMfaDto} initiateSmsMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerInitiateSmsMfa: async (initiateSmsMfaDto, options = {}) => {
            // verify required parameter 'initiateSmsMfaDto' is not null or undefined
            assertParamExists('mfaControllerInitiateSmsMfa', 'initiateSmsMfaDto', initiateSmsMfaDto);
            const localVarPath = `/api/mfa/sms/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(initiateSmsMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Dev: List current WhatsApp backup code state
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerListWhatsAppBackupCodes: async (generateBackupCodeDto, options = {}) => {
            // verify required parameter 'generateBackupCodeDto' is not null or undefined
            assertParamExists('mfaControllerListWhatsAppBackupCodes', 'generateBackupCodeDto', generateBackupCodeDto);
            const localVarPath = `/api/mfa/whatsapp/backup/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(generateBackupCodeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register phone number for SMS MFA
         * @param {SetupSmsMfaRegisterDto} setupSmsMfaRegisterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerRegisterSmsMfa: async (setupSmsMfaRegisterDto, options = {}) => {
            // verify required parameter 'setupSmsMfaRegisterDto' is not null or undefined
            assertParamExists('mfaControllerRegisterSmsMfa', 'setupSmsMfaRegisterDto', setupSmsMfaRegisterDto);
            const localVarPath = `/api/mfa/sms/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setupSmsMfaRegisterDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Setup WhatsApp MFA by sending an OTP
         * @param {SetupWhatsAppMfaDto} setupWhatsAppMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerSetupWhatsAppMfa: async (setupWhatsAppMfaDto, options = {}) => {
            // verify required parameter 'setupWhatsAppMfaDto' is not null or undefined
            assertParamExists('mfaControllerSetupWhatsAppMfa', 'setupWhatsAppMfaDto', setupWhatsAppMfaDto);
            const localVarPath = `/api/mfa/whatsapp/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setupWhatsAppMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify SMS MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifySmsMfa: async (verifyMfaDto, options = {}) => {
            // verify required parameter 'verifyMfaDto' is not null or undefined
            assertParamExists('mfaControllerVerifySmsMfa', 'verifyMfaDto', verifyMfaDto);
            const localVarPath = `/api/mfa/sms/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify SMS MFA registration by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifySmsMfaRegistration: async (verifyMfaDto, options = {}) => {
            // verify required parameter 'verifyMfaDto' is not null or undefined
            assertParamExists('mfaControllerVerifySmsMfaRegistration', 'verifyMfaDto', verifyMfaDto);
            const localVarPath = `/api/mfa/sms/register/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify MFA using a backup code (WhatsApp fallback)
         * @param {BackupCodeDto} backupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifyWhatsAppBackupCode: async (backupCodeDto, options = {}) => {
            // verify required parameter 'backupCodeDto' is not null or undefined
            assertParamExists('mfaControllerVerifyWhatsAppBackupCode', 'backupCodeDto', backupCodeDto);
            const localVarPath = `/api/mfa/whatsapp/backup/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(backupCodeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify WhatsApp MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifyWhatsAppMfa: async (verifyMfaDto, options = {}) => {
            // verify required parameter 'verifyMfaDto' is not null or undefined
            assertParamExists('mfaControllerVerifyWhatsAppMfa', 'verifyMfaDto', verifyMfaDto);
            const localVarPath = `/api/mfa/whatsapp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(verifyMfaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MFAApi - functional programming interface
 * @export
 */
export const MFAApiFp = function (configuration) {
    const localVarAxiosParamCreator = MFAApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Dev: Generate WhatsApp MFA backup codes (single-use)
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerGenerateWhatsAppBackupCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Initiate SMS MFA for login by sending an OTP
         * @param {InitiateSmsMfaDto} initiateSmsMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerInitiateSmsMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Dev: List current WhatsApp backup code state
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerListWhatsAppBackupCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Register phone number for SMS MFA
         * @param {SetupSmsMfaRegisterDto} setupSmsMfaRegisterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerRegisterSmsMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Setup WhatsApp MFA by sending an OTP
         * @param {SetupWhatsAppMfaDto} setupWhatsAppMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerSetupWhatsAppMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Verify SMS MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerVerifySmsMfa(verifyMfaDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerVerifySmsMfa(verifyMfaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerVerifySmsMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Verify SMS MFA registration by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerVerifySmsMfaRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Verify MFA using a backup code (WhatsApp fallback)
         * @param {BackupCodeDto} backupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerVerifyWhatsAppBackupCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Verify WhatsApp MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAApi.mfaControllerVerifyWhatsAppMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * MFAApi - factory interface
 * @export
 */
export const MFAApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MFAApiFp(configuration);
    return {
        /**
         *
         * @summary Dev: Generate WhatsApp MFA backup codes (single-use)
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options) {
            return localVarFp.mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initiate SMS MFA for login by sending an OTP
         * @param {InitiateSmsMfaDto} initiateSmsMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options) {
            return localVarFp.mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Dev: List current WhatsApp backup code state
         * @param {GenerateBackupCodeDto} generateBackupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options) {
            return localVarFp.mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Register phone number for SMS MFA
         * @param {SetupSmsMfaRegisterDto} setupSmsMfaRegisterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options) {
            return localVarFp.mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Setup WhatsApp MFA by sending an OTP
         * @param {SetupWhatsAppMfaDto} setupWhatsAppMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options) {
            return localVarFp.mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify SMS MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifySmsMfa(verifyMfaDto, options) {
            return localVarFp.mfaControllerVerifySmsMfa(verifyMfaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify SMS MFA registration by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options) {
            return localVarFp.mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify MFA using a backup code (WhatsApp fallback)
         * @param {BackupCodeDto} backupCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options) {
            return localVarFp.mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify WhatsApp MFA by validating the OTP
         * @param {VerifyMfaDto} verifyMfaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options) {
            return localVarFp.mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MFAApi - object-oriented interface
 * @export
 * @class MFAApi
 * @extends {BaseAPI}
 */
export class MFAApi extends BaseAPI {
    /**
     *
     * @summary Dev: Generate WhatsApp MFA backup codes (single-use)
     * @param {GenerateBackupCodeDto} generateBackupCodeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options) {
        return MFAApiFp(this.configuration).mfaControllerGenerateWhatsAppBackupCodes(generateBackupCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initiate SMS MFA for login by sending an OTP
     * @param {InitiateSmsMfaDto} initiateSmsMfaDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options) {
        return MFAApiFp(this.configuration).mfaControllerInitiateSmsMfa(initiateSmsMfaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Dev: List current WhatsApp backup code state
     * @param {GenerateBackupCodeDto} generateBackupCodeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options) {
        return MFAApiFp(this.configuration).mfaControllerListWhatsAppBackupCodes(generateBackupCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Register phone number for SMS MFA
     * @param {SetupSmsMfaRegisterDto} setupSmsMfaRegisterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options) {
        return MFAApiFp(this.configuration).mfaControllerRegisterSmsMfa(setupSmsMfaRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Setup WhatsApp MFA by sending an OTP
     * @param {SetupWhatsAppMfaDto} setupWhatsAppMfaDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options) {
        return MFAApiFp(this.configuration).mfaControllerSetupWhatsAppMfa(setupWhatsAppMfaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify SMS MFA by validating the OTP
     * @param {VerifyMfaDto} verifyMfaDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerVerifySmsMfa(verifyMfaDto, options) {
        return MFAApiFp(this.configuration).mfaControllerVerifySmsMfa(verifyMfaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify SMS MFA registration by validating the OTP
     * @param {VerifyMfaDto} verifyMfaDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options) {
        return MFAApiFp(this.configuration).mfaControllerVerifySmsMfaRegistration(verifyMfaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify MFA using a backup code (WhatsApp fallback)
     * @param {BackupCodeDto} backupCodeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options) {
        return MFAApiFp(this.configuration).mfaControllerVerifyWhatsAppBackupCode(backupCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify WhatsApp MFA by validating the OTP
     * @param {VerifyMfaDto} verifyMfaDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAApi
     */
    mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options) {
        return MFAApiFp(this.configuration).mfaControllerVerifyWhatsAppMfa(verifyMfaDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OAuthApi - axios parameter creator
 * @export
 */
export const OAuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Handles Facebook OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...).
         * @summary OAuth: Facebook callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerFacebookCallback: async (options = {}) => {
            const localVarPath = `/api/auth/facebook/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirects user to Facebook OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.
         * @summary OAuth: Initiate Facebook login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerFacebookLogin: async (returnTo, options = {}) => {
            const localVarPath = `/api/auth/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (returnTo !== undefined) {
                localVarQueryParameter['returnTo'] = returnTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles Google OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...). On failure, redirects to /login with error params (error, provider, error_description).
         * @summary OAuth: Google callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerGoogleCallback: async (options = {}) => {
            const localVarPath = `/api/auth/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirects user to Google OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.  Flow: - Client calls GET /api/auth/google?returnTo=https://app.example.com - User completes Google consent - Server redirects to /api/auth/google/callback - On success -> redirects to {returnTo}/login#accessToken=...&refreshToken=...&jti=...  Examples (errors at callback redirect): - not-linked: /login?error=not-linked&provider=google&error_description=Account%20not%20linked - oauth-failed: /login?error=oauth-failed&provider=google&error_description=Access%20denied
         * @summary OAuth: Initiate Google login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerGoogleLogin: async (returnTo, options = {}) => {
            const localVarPath = `/api/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (returnTo !== undefined) {
                localVarQueryParameter['returnTo'] = returnTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates linking an existing user account with a social provider (Google or Facebook). Requires authentication. Redirects to provider consent screen.
         * @summary OAuth: Link social account
         * @param {OAuthControllerLinkProviderEnum} provider OAuth provider to link
         * @param {string} [returnTo] Optional return URL after linking. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerLink: async (provider, returnTo, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('oAuthControllerLink', 'provider', provider);
            const localVarPath = `/api/auth/{provider}/link`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (returnTo !== undefined) {
                localVarQueryParameter['returnTo'] = returnTo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles provider callback after successful account linking. Redirects to return URL with success status in fragment.
         * @summary OAuth: Link callback (internal)
         * @param {OAuthControllerLinkCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerLinkCallback: async (provider, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('oAuthControllerLinkCallback', 'provider', provider);
            const localVarPath = `/api/auth/{provider}/link/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all available OAuth providers and their link status for the authenticated user.
         * @summary OAuth: List linked social providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerListProviders: async (options = {}) => {
            const localVarPath = `/api/auth/social/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles provider callback after social signup consent. Issues a signup token and redirects to return URL with token in fragment (#signup_token=...&provider=...).
         * @summary OAuth: Signup callback (internal)
         * @param {OAuthControllerSignupCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerSignupCallback: async (provider, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('oAuthControllerSignupCallback', 'provider', provider);
            const localVarPath = `/api/auth/{provider}/signup/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates new user registration via social provider (Google or Facebook). Redirects to provider consent screen. After consent, issues a signup token for registration completion.
         * @summary OAuth: Initiate social signup
         * @param {OAuthControllerSignupStartProviderEnum} provider OAuth provider for signup
         * @param {string} [returnTo] Optional return URL after signup. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {string} [profile] Optional policy profile name for domain allowlist and ToS requirements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerSignupStart: async (provider, returnTo, profile, options = {}) => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('oAuthControllerSignupStart', 'provider', provider);
            const localVarPath = `/api/auth/{provider}/signup`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (returnTo !== undefined) {
                localVarQueryParameter['returnTo'] = returnTo;
            }
            if (profile !== undefined) {
                localVarQueryParameter['profile'] = profile;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the link between the authenticated user and a social provider (Google or Facebook).
         * @summary OAuth: Unlink social account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerUnlink: async (options = {}) => {
            const localVarPath = `/api/auth/social/unlink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OAuthApi - functional programming interface
 * @export
 */
export const OAuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = OAuthApiAxiosParamCreator(configuration);
    return {
        /**
         * Handles Facebook OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...).
         * @summary OAuth: Facebook callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerFacebookCallback(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerFacebookCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerFacebookCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirects user to Facebook OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.
         * @summary OAuth: Initiate Facebook login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerFacebookLogin(returnTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerFacebookLogin(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerFacebookLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles Google OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...). On failure, redirects to /login with error params (error, provider, error_description).
         * @summary OAuth: Google callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerGoogleCallback(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerGoogleCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerGoogleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirects user to Google OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.  Flow: - Client calls GET /api/auth/google?returnTo=https://app.example.com - User completes Google consent - Server redirects to /api/auth/google/callback - On success -> redirects to {returnTo}/login#accessToken=...&refreshToken=...&jti=...  Examples (errors at callback redirect): - not-linked: /login?error=not-linked&provider=google&error_description=Account%20not%20linked - oauth-failed: /login?error=oauth-failed&provider=google&error_description=Access%20denied
         * @summary OAuth: Initiate Google login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerGoogleLogin(returnTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerGoogleLogin(returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerGoogleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates linking an existing user account with a social provider (Google or Facebook). Requires authentication. Redirects to provider consent screen.
         * @summary OAuth: Link social account
         * @param {OAuthControllerLinkProviderEnum} provider OAuth provider to link
         * @param {string} [returnTo] Optional return URL after linking. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerLink(provider, returnTo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerLink(provider, returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles provider callback after successful account linking. Redirects to return URL with success status in fragment.
         * @summary OAuth: Link callback (internal)
         * @param {OAuthControllerLinkCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerLinkCallback(provider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerLinkCallback(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerLinkCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all available OAuth providers and their link status for the authenticated user.
         * @summary OAuth: List linked social providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerListProviders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerListProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerListProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles provider callback after social signup consent. Issues a signup token and redirects to return URL with token in fragment (#signup_token=...&provider=...).
         * @summary OAuth: Signup callback (internal)
         * @param {OAuthControllerSignupCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerSignupCallback(provider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerSignupCallback(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerSignupCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates new user registration via social provider (Google or Facebook). Redirects to provider consent screen. After consent, issues a signup token for registration completion.
         * @summary OAuth: Initiate social signup
         * @param {OAuthControllerSignupStartProviderEnum} provider OAuth provider for signup
         * @param {string} [returnTo] Optional return URL after signup. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {string} [profile] Optional policy profile name for domain allowlist and ToS requirements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerSignupStart(provider, returnTo, profile, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerSignupStart(provider, returnTo, profile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerSignupStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the link between the authenticated user and a social provider (Google or Facebook).
         * @summary OAuth: Unlink social account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oAuthControllerUnlink(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oAuthControllerUnlink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.oAuthControllerUnlink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OAuthApi - factory interface
 * @export
 */
export const OAuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OAuthApiFp(configuration);
    return {
        /**
         * Handles Facebook OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...).
         * @summary OAuth: Facebook callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerFacebookCallback(options) {
            return localVarFp.oAuthControllerFacebookCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * Redirects user to Facebook OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.
         * @summary OAuth: Initiate Facebook login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerFacebookLogin(returnTo, options) {
            return localVarFp.oAuthControllerFacebookLogin(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles Google OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...). On failure, redirects to /login with error params (error, provider, error_description).
         * @summary OAuth: Google callback (internal)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerGoogleCallback(options) {
            return localVarFp.oAuthControllerGoogleCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * Redirects user to Google OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.  Flow: - Client calls GET /api/auth/google?returnTo=https://app.example.com - User completes Google consent - Server redirects to /api/auth/google/callback - On success -> redirects to {returnTo}/login#accessToken=...&refreshToken=...&jti=...  Examples (errors at callback redirect): - not-linked: /login?error=not-linked&provider=google&error_description=Account%20not%20linked - oauth-failed: /login?error=oauth-failed&provider=google&error_description=Access%20denied
         * @summary OAuth: Initiate Google login
         * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerGoogleLogin(returnTo, options) {
            return localVarFp.oAuthControllerGoogleLogin(returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates linking an existing user account with a social provider (Google or Facebook). Requires authentication. Redirects to provider consent screen.
         * @summary OAuth: Link social account
         * @param {OAuthControllerLinkProviderEnum} provider OAuth provider to link
         * @param {string} [returnTo] Optional return URL after linking. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerLink(provider, returnTo, options) {
            return localVarFp.oAuthControllerLink(provider, returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles provider callback after successful account linking. Redirects to return URL with success status in fragment.
         * @summary OAuth: Link callback (internal)
         * @param {OAuthControllerLinkCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerLinkCallback(provider, options) {
            return localVarFp.oAuthControllerLinkCallback(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all available OAuth providers and their link status for the authenticated user.
         * @summary OAuth: List linked social providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerListProviders(options) {
            return localVarFp.oAuthControllerListProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * Handles provider callback after social signup consent. Issues a signup token and redirects to return URL with token in fragment (#signup_token=...&provider=...).
         * @summary OAuth: Signup callback (internal)
         * @param {OAuthControllerSignupCallbackProviderEnum} provider OAuth provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerSignupCallback(provider, options) {
            return localVarFp.oAuthControllerSignupCallback(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates new user registration via social provider (Google or Facebook). Redirects to provider consent screen. After consent, issues a signup token for registration completion.
         * @summary OAuth: Initiate social signup
         * @param {OAuthControllerSignupStartProviderEnum} provider OAuth provider for signup
         * @param {string} [returnTo] Optional return URL after signup. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
         * @param {string} [profile] Optional policy profile name for domain allowlist and ToS requirements.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerSignupStart(provider, returnTo, profile, options) {
            return localVarFp.oAuthControllerSignupStart(provider, returnTo, profile, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the link between the authenticated user and a social provider (Google or Facebook).
         * @summary OAuth: Unlink social account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oAuthControllerUnlink(options) {
            return localVarFp.oAuthControllerUnlink(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OAuthApi - object-oriented interface
 * @export
 * @class OAuthApi
 * @extends {BaseAPI}
 */
export class OAuthApi extends BaseAPI {
    /**
     * Handles Facebook OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...).
     * @summary OAuth: Facebook callback (internal)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerFacebookCallback(options) {
        return OAuthApiFp(this.configuration).oAuthControllerFacebookCallback(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redirects user to Facebook OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.
     * @summary OAuth: Initiate Facebook login
     * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerFacebookLogin(returnTo, options) {
        return OAuthApiFp(this.configuration).oAuthControllerFacebookLogin(returnTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Handles Google OAuth callback. Issues JWT tokens and redirects to return URL with tokens in URL fragment (#accessToken=...&refreshToken=...&jti=...). On failure, redirects to /login with error params (error, provider, error_description).
     * @summary OAuth: Google callback (internal)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerGoogleCallback(options) {
        return OAuthApiFp(this.configuration).oAuthControllerGoogleCallback(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redirects user to Google OAuth consent screen. After successful authentication, user is redirected to the callback endpoint with tokens in URL fragment.  Flow: - Client calls GET /api/auth/google?returnTo=https://app.example.com - User completes Google consent - Server redirects to /api/auth/google/callback - On success -> redirects to {returnTo}/login#accessToken=...&refreshToken=...&jti=...  Examples (errors at callback redirect): - not-linked: /login?error=not-linked&provider=google&error_description=Account%20not%20linked - oauth-failed: /login?error=oauth-failed&provider=google&error_description=Access%20denied
     * @summary OAuth: Initiate Google login
     * @param {string} [returnTo] Optional return URL after successful authentication. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerGoogleLogin(returnTo, options) {
        return OAuthApiFp(this.configuration).oAuthControllerGoogleLogin(returnTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiates linking an existing user account with a social provider (Google or Facebook). Requires authentication. Redirects to provider consent screen.
     * @summary OAuth: Link social account
     * @param {OAuthControllerLinkProviderEnum} provider OAuth provider to link
     * @param {string} [returnTo] Optional return URL after linking. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerLink(provider, returnTo, options) {
        return OAuthApiFp(this.configuration).oAuthControllerLink(provider, returnTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Handles provider callback after successful account linking. Redirects to return URL with success status in fragment.
     * @summary OAuth: Link callback (internal)
     * @param {OAuthControllerLinkCallbackProviderEnum} provider OAuth provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerLinkCallback(provider, options) {
        return OAuthApiFp(this.configuration).oAuthControllerLinkCallback(provider, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves all available OAuth providers and their link status for the authenticated user.
     * @summary OAuth: List linked social providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerListProviders(options) {
        return OAuthApiFp(this.configuration).oAuthControllerListProviders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Handles provider callback after social signup consent. Issues a signup token and redirects to return URL with token in fragment (#signup_token=...&provider=...).
     * @summary OAuth: Signup callback (internal)
     * @param {OAuthControllerSignupCallbackProviderEnum} provider OAuth provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerSignupCallback(provider, options) {
        return OAuthApiFp(this.configuration).oAuthControllerSignupCallback(provider, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiates new user registration via social provider (Google or Facebook). Redirects to provider consent screen. After consent, issues a signup token for registration completion.
     * @summary OAuth: Initiate social signup
     * @param {OAuthControllerSignupStartProviderEnum} provider OAuth provider for signup
     * @param {string} [returnTo] Optional return URL after signup. Defaults to configured OAUTH_RETURN_TO_DEFAULT.
     * @param {string} [profile] Optional policy profile name for domain allowlist and ToS requirements.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerSignupStart(provider, returnTo, profile, options) {
        return OAuthApiFp(this.configuration).oAuthControllerSignupStart(provider, returnTo, profile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes the link between the authenticated user and a social provider (Google or Facebook).
     * @summary OAuth: Unlink social account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuthApi
     */
    oAuthControllerUnlink(options) {
        return OAuthApiFp(this.configuration).oAuthControllerUnlink(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const OAuthControllerLinkProviderEnum = {
    Google: 'google',
    Facebook: 'facebook'
};
/**
 * @export
 */
export const OAuthControllerLinkCallbackProviderEnum = {
    Google: 'google',
    Facebook: 'facebook'
};
/**
 * @export
 */
export const OAuthControllerSignupCallbackProviderEnum = {
    Google: 'google',
    Facebook: 'facebook'
};
/**
 * @export
 */
export const OAuthControllerSignupStartProviderEnum = {
    Google: 'google',
    Facebook: 'facebook'
};
/**
 * OTPApi - axios parameter creator
 * @export
 */
export const OTPApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Allows sending of OTPs to a user via WhatsApp for verification purposes.
         * @summary Send OTP via WhatsApp
         * @param {SendOtpDto} sendOtpDto Data Transfer Object containing recipient phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpControllerSendOtp: async (sendOtpDto, options = {}) => {
            // verify required parameter 'sendOtpDto' is not null or undefined
            assertParamExists('otpControllerSendOtp', 'sendOtpDto', sendOtpDto);
            const localVarPath = `/api/otp/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OTPApi - functional programming interface
 * @export
 */
export const OTPApiFp = function (configuration) {
    const localVarAxiosParamCreator = OTPApiAxiosParamCreator(configuration);
    return {
        /**
         * Allows sending of OTPs to a user via WhatsApp for verification purposes.
         * @summary Send OTP via WhatsApp
         * @param {SendOtpDto} sendOtpDto Data Transfer Object containing recipient phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpControllerSendOtp(sendOtpDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpControllerSendOtp(sendOtpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OTPApi.otpControllerSendOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OTPApi - factory interface
 * @export
 */
export const OTPApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OTPApiFp(configuration);
    return {
        /**
         * Allows sending of OTPs to a user via WhatsApp for verification purposes.
         * @summary Send OTP via WhatsApp
         * @param {SendOtpDto} sendOtpDto Data Transfer Object containing recipient phone number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpControllerSendOtp(sendOtpDto, options) {
            return localVarFp.otpControllerSendOtp(sendOtpDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OTPApi - object-oriented interface
 * @export
 * @class OTPApi
 * @extends {BaseAPI}
 */
export class OTPApi extends BaseAPI {
    /**
     * Allows sending of OTPs to a user via WhatsApp for verification purposes.
     * @summary Send OTP via WhatsApp
     * @param {SendOtpDto} sendOtpDto Data Transfer Object containing recipient phone number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OTPApi
     */
    otpControllerSendOtp(sendOtpDto, options) {
        return OTPApiFp(this.configuration).otpControllerSendOtp(sendOtpDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WhatsAppHealthApi - axios parameter creator
 * @export
 */
export const WhatsAppHealthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppHealthControllerGet: async (template, lang, options = {}) => {
            // verify required parameter 'template' is not null or undefined
            assertParamExists('whatsAppHealthControllerGet', 'template', template);
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('whatsAppHealthControllerGet', 'lang', lang);
            const localVarPath = `/api/messaging/whatsapp/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WhatsAppHealthApi - functional programming interface
 * @export
 */
export const WhatsAppHealthApiFp = function (configuration) {
    const localVarAxiosParamCreator = WhatsAppHealthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppHealthControllerGet(template, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppHealthControllerGet(template, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppHealthApi.whatsAppHealthControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WhatsAppHealthApi - factory interface
 * @export
 */
export const WhatsAppHealthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WhatsAppHealthApiFp(configuration);
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppHealthControllerGet(template, lang, options) {
            return localVarFp.whatsAppHealthControllerGet(template, lang, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WhatsAppHealthApi - object-oriented interface
 * @export
 * @class WhatsAppHealthApi
 * @extends {BaseAPI}
 */
export class WhatsAppHealthApi extends BaseAPI {
    /**
     *
     * @param {string} template
     * @param {string} lang
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppHealthApi
     */
    whatsAppHealthControllerGet(template, lang, options) {
        return WhatsAppHealthApiFp(this.configuration).whatsAppHealthControllerGet(template, lang, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WhatsAppWebhookApi - axios parameter creator
 * @export
 */
export const WhatsAppWebhookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleVerify: async (options = {}) => {
            const localVarPath = `/api/messaging/webhook/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleWebhook: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('whatsAppWebhookControllerHandleWebhook', 'body', body);
            const localVarPath = `/api/messaging/webhook/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHealth: async (options = {}) => {
            const localVarPath = `/api/messaging/webhook/whatsapp/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WhatsAppWebhookApi - functional programming interface
 * @export
 */
export const WhatsAppWebhookApiFp = function (configuration) {
    const localVarAxiosParamCreator = WhatsAppWebhookApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHandleVerify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHandleVerify(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHandleVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHandleWebhook(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHandleWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHandleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHealth(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WhatsAppWebhookApi - factory interface
 * @export
 */
export const WhatsAppWebhookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WhatsAppWebhookApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleVerify(options) {
            return localVarFp.whatsAppWebhookControllerHandleVerify(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleWebhook(body, options) {
            return localVarFp.whatsAppWebhookControllerHandleWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHealth(options) {
            return localVarFp.whatsAppWebhookControllerHealth(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WhatsAppWebhookApi - object-oriented interface
 * @export
 * @class WhatsAppWebhookApi
 * @extends {BaseAPI}
 */
export class WhatsAppWebhookApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHandleVerify(options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHandleVerify(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHandleWebhook(body, options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHandleWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHealth(options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHealth(options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map